import { PROCESSED_NOTIFICATION_KINDS } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetActiveUserSetLeads } from 'cpool-tables/backend-resolvers';
import { useTranslation } from 'react-i18next';

import { NotificationItemRow } from './NotificationItemRow';
import { useUserDisplayName } from '~/components/Dialogs/hooks/useUserDisplayName';
import { useMarkNotificationProcessed } from '~/features/notifications/hooks/useMarkNotificationProcessed';
import { getApplicantPreviewName } from '~/features/notifications/utils/getApplicantPreviewName';
import { getNotificationLinkOptions } from '~/features/notifications/utils/getNotificationLinkOptions';

type Props = {
    lead: SchemaLoanRequestResolver_GetActiveUserSetLeads[number];
    onNavigate: () => void;
};

export const ActiveUserSetNotificationRow: React.FC<Props> = ({ lead, onNavigate }) => {
    const { t } = useTranslation();
    const setByName = useUserDisplayName(lead.activeUserSet?.setBy);
    const { mutate: markProcessed } = useMarkNotificationProcessed();
    const { activeUserSet } = lead;
    if (!activeUserSet) return null;

    return (
        <NotificationItemRow
            previewName={getApplicantPreviewName(lead.antragsteller1?.personendaten)}
            previewDetail={t('TOP_HEADER.NOTIFICATIONS.ACTIVE_USER_SET_BY', {
                name: setByName ?? t('LEADS.ASSIGNED_USERS.UNKNOWN_USER'),
            })}
            timestamp={activeUserSet.setAt}
            link={getNotificationLinkOptions(PROCESSED_NOTIFICATION_KINDS.ACTIVE_USER_SET, lead.id)}
            onNavigate={() => {
                markProcessed({
                    kind: PROCESSED_NOTIFICATION_KINDS.ACTIVE_USER_SET,
                    loanRequestId: lead.id,
                    setAt: activeUserSet.setAt,
                });
                onNavigate();
            }}
        />
    );
};
